var viewer_rtlignore_default = {
  "gallery_container": "r5loC",
  "imageTitleContainer": "wB-Xv",
  "clickableItem": "o6QSg",
  "prerender": "_03OvC",
  "expandContainer": "-GEHu",
  "expandIcon": "CAMNN",
  "itemOverlay": "Rnv3g",
  "imageTitle": "uZBTi",
  "pointer": "_1CyDU",
  "fadeIn": "I0Gb4",
  "changing_background": "n94op"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
